export default __webpack_public_path__ + "static/media/BG.b96c9eed.jpg";